<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import Watermark from '@/plugins/watermark.js'
export default {
	data() {
		return {
			cashViews: ['Home', 'Writemail', 'Search']
		}
	},
	computed: {
		// 获取用户信息
		userInfo() {
			return this.$store.state.User.userInfo
		}
	},
	created() {},
	mounted() {
		// 给页面添加水印
		let opt = {
			el: '#app',
			fillText: this.userInfo.UserName + ' ' + this.userInfo.empNo,
			rotate: -19.67,
			font: `normal 14px "Microsoft YaHei"`
		}
		Watermark.set(opt)
    this.$api.traceUserInfo();
	}
}
</script>
<style lang="scss">
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #333;
	margin: 0 auto;
	height: 100%;
	font-size: 14px;

}
</style>
